import { APP_LAST_UPDATED, GROUP_ACCOUNTS_SHOW_MESSAGE, GROUP_ACCOUNTS_LOAD, GROUP_ACCOUNTS_RESET_REDUCER } from '../types'
import { chkExpiredData, groupStatusCheck } from '../app/actions'
import { getFunctions, httpsCallable } from 'firebase/functions'

export function setShowMessage(){
	return (dispatch, getstate, firebase) => {
		dispatch({ type:GROUP_ACCOUNTS_SHOW_MESSAGE, payload:false })
	}
}

export function loadGroupAccounts(force=false) {
	return (dispatch, getstate, firebase) => new Promise(function (resolve, reject) {    
	   const chkIfExpired = dispatch(chkExpiredData(force, 'groupAccounts'))
     	chkIfExpired
     	.then(async (currentTime) => {
     	// ---------------------------------------------------------------------------    
	      const user = await dispatch(groupStatusCheck('groupAccounts', GROUP_ACCOUNTS_RESET_REDUCER))  
        const teamMemberId = user.teamMemberId   
        const groupId = user.groupId

	      const functions = getFunctions(firebase)
        const fetchGroupAccounts = httpsCallable(functions, 'groupFetchAccounts')
	      fetchGroupAccounts({ teamMemberId, groupId })
	      .then((returned) => {
	      	let payload = {
	      		accounts:returned.data.accounts
	      	}
   			  dispatch({ type: GROUP_ACCOUNTS_LOAD, payload: payload })
	  			dispatch({ type: APP_LAST_UPDATED, payload:{key:'groupAccounts', value:currentTime} })
		  		resolve()
	      })
	      .catch((e) => {
	      	let error = {title:'Error',message:''}
	      	try { error = JSON.parse(e.message) } 
	      	catch (err) { error.message = (e.message === 'internal') ? 'Error connecting to server.' : e.message }
	      	reject(error)
	      }) 
     	// ---------------------------------------------------------------------------
     	})
     	.catch(() => {
         // Current data still good so do nothing.
         resolve()
     	})
	})
}
